export default {
  webstoreContent: {},
  checkoutContent: {},
  footerContent: {},
  checkoutSharedContent: {},
  webstoreProductContent: {},
  webstoreGlobals: {},
  testProduct: {},
  renewalsPersistedVariables: {},
};
